module.exports = __webpack_public_path__ + "static/media/telegram_16px.3fc70160.svg";